import React, { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { postAnon } from '../api';
import { TextInput } from '../components/TextInput';
import { Button } from '../components/Button';
import { useSEO } from '../hooks/useSEO';

function ForgotPassword() {
  useSEO({ title: 'Forgot password – Compress GLB', robots: 'noindex, follow' });

    const [username, setUsername] = useState('');
    const [message, setMessage] = useState('');
    const [apiError, setApiError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setApiError('');
        setMessage('');
        setLoading(true);

        try {
            await postAnon('/api/1/auth/forgot-password', { username });
            setMessage('If an account exists for this email, a password reset link has been sent.');
            setUsername('');
        } catch (err) {
            console.error("Forgot password error:", err);
            setMessage('If an account exists for this email, a password reset link has been sent.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-background w-screen min-h-screen flex justify-center items-center px-4 py-10">
            <div className="bg-background-elevated p-8 md:p-10 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200 w-full max-w-md space-y-6 border border-border/60">
                <header className="space-y-2 text-center">
                    <h2 className="text-2xl font-semibold text-foreground tracking-tight">Forgot Password</h2>
                    <p className="text-sm text-muted-foreground">
                        Enter your email address and you'll receive a link to reset your password.
                    </p>
                </header>
                
                {message && (
                  <div 
                    role="status" 
                    className="bg-success/10 border border-success/20 text-success px-4 py-3 rounded-lg text-sm"
                  >
                    {message}
                  </div>
                )}

                <form className="space-y-5" onSubmit={handleSubmit}>
                    <TextInput
                        label="Email Address"
                        id="username"
                        name="username"
                        type="email"
                        autoComplete="email"
                        required
                        placeholder="you@example.com"
                        value={username}
                        onChange={(e) => {
                            setUsername(e.target.value);
                            if (message) setMessage('');
                            if (apiError) setApiError('');
                        }}
                        disabled={loading}
                    />

                    <Button
                        type="submit"
                        disabled={loading}
                        className="w-full"
                        size="lg"
                    >
                        {loading ? 'Sending...' : 'Send Reset Link'}
                    </Button>
                </form>
                <div className="text-sm text-center pt-2">
                    <Link to="/sign-in" className="text-accent hover:text-accent/90 font-medium transition-colors">
                        Back to Sign In
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;